import { Outlet } from "react-router-dom"

export const LoginLayout = () => {
  return (
    <Outlet />
  )
}
